import { CoreTypography } from '@youscience/core';

import { PLAN_CARD } from '@interfaces/nonLearnerHomePage';

import { useAnyCommonAppEnabled } from '@hooks/useAnyCommonAppEnabled';

import { CARD_IDS } from '@constants/baseHomePage';

import NavigationCard from '@components/NavigationCard';
import { Container } from '@components/Layout/components/Container';

import StateSpotlightBanner from './components/StateSpotlightBanner';
import { sxStyles, StyledSectionInner, StyledCardsWrap } from './PlanForCollege.styles';

interface PlanForCollegeProps {
  cards: PLAN_CARD[];
}

export const PlanForCollege = (props: PlanForCollegeProps) => {
  const { cards } = props;

  const { anyTenantHasCommonApp } = useAnyCommonAppEnabled();

  return (
    <Container>
      <StyledSectionInner>
        <CoreTypography sx={sxStyles.title} variant="h2">
          Plan for college
        </CoreTypography>

        <StyledCardsWrap>
          {cards
            .filter((card) => {
              if (card.id === CARD_IDS.EDUCATION_PLANNER_APPLICATIONS) {
                return !anyTenantHasCommonApp;
              }
              if (
                card.id === CARD_IDS.EDUCATION_PLANNER_APPLICATIONS_COMMON_APP ||
                card.id === CARD_IDS.RECOMMENDER_SPACE
              ) {
                return anyTenantHasCommonApp;
              }
              return true;
            })
            .map(({ id, title, icon, navigationUrl }) => (
              <NavigationCard key={id} icon={icon} title={title} navigationUrl={navigationUrl} />
            ))}
        </StyledCardsWrap>

        <StateSpotlightBanner />
      </StyledSectionInner>
    </Container>
  );
};
